// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { Row, Col } from 'antd/lib/grid';
import Popover from 'antd/lib/popover';
import Button from 'antd/lib/button';
import Text from 'antd/lib/typography/Text';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
    LockOutlined,
    UnlockOutlined,
    EyeInvisibleOutlined,
    EyeOutlined,
} from '@ant-design/icons';

import ColorChanger from 'components/annotation-page/standard-workspace/objects-side-bar/color-changer';

interface Props {
    labelName: string;
    labelColor: string;
    labelColors: string[];
    visible: boolean;
    statesHidden: boolean;
    statesLocked: boolean;
    hideStates(): void;
    showStates(): void;
    lockStates(): void;
    unlockStates(): void;
    changeColor(color: string): void;
}

function LabelItemComponent(props: Props): JSX.Element {
    const {
        labelName,
        labelColor,
        labelColors,
        visible,
        statesHidden,
        statesLocked,
        hideStates,
        showStates,
        lockStates,
        unlockStates,
        changeColor,
    } = props;

    const classes = {
        lock: {
            enabled: { className: 'cvat-label-item-button-lock cvat-label-item-button-lock-enabled' },
            disabled: { className: 'cvat-label-item-button-lock' },
        },
        hidden: {
            enabled: { className: 'cvat-label-item-button-hidden cvat-label-item-button-hidden-enabled' },
            disabled: { className: 'cvat-label-item-button-hidden' },
        },
    };

    return (
        <Row
            align='middle'
            justify='space-around'
            className='cvat-objects-sidebar-label-item'
            style={{ display: visible ? 'flex' : 'none' }}
        >
            <Col span={4}>
                <Popover
                    placement='left'
                    trigger='click'
                    content={(
                        <ColorChanger
                            onChange={changeColor}
                            colors={labelColors}
                        />
                    )}
                >
                    <Button style={{ background: labelColor }} className='cvat-label-item-color-button'>&nbsp;</Button>
                </Popover>
            </Col>
            <Col span={14}>
                <Text strong className='cvat-text'>{labelName}</Text>
            </Col>
            <Col span={3}>
                {statesLocked ? (
                    <LockOutlined {...classes.lock.enabled} onClick={unlockStates} rev='' />
                ) : (
                    <UnlockOutlined {...classes.lock.disabled} onClick={lockStates} rev='' />
                )}
            </Col>
            <Col span={3}>
                { statesHidden ? (
                    <EyeInvisibleOutlined {...classes.hidden.enabled} onClick={showStates} rev='' />
                ) : (
                    <EyeOutlined {...classes.hidden.disabled} onClick={hideStates} rev='' />
                )}
            </Col>
        </Row>
    );
}

export default React.memo(LabelItemComponent);
